var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v90H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.541 53.157c-2.449 8.714-4.469 16.034-4.633 17.026A2.076 2.076 0 0 1 37.83 72h-.232a2.079 2.079 0 0 1-1.825-2.286c.09-.818 1.731-6.844 3.734-14.01-2.831 1.317-5.16 2.169-6.596 2.346a5.26 5.26 0 0 1-.698.05c-1.406 0-2.114-.67-2.466-1.26a2.073 2.073 0 0 1 .278-2.457 2.079 2.079 0 0 1 2.436-.445c1.235-.174 4.396-1.471 8.55-3.623a5101.999 5101.999 0 0 1 5.311-18.696 2.077 2.077 0 0 1 3.993 1.14c-1.275 4.458-2.758 9.66-4.198 14.747a127.79 127.79 0 0 0 5.597-3.418c10.378-6.704 17.447-13.112 18.873-17.198.537-1.525.145-2.229-.614-2.815-1.818-1.411-7.408-1.585-17.648 2.148-15.347 5.594-31.56 16.457-33.107 22.121.158.031.319.046.48.044a2.073 2.073 0 1 1 .188 4.143c-.44.02-2.708.053-4.027-1.509a3.801 3.801 0 0 1-.741-3.352c1.033-4.836 7.64-10.132 12.998-13.748a110.323 110.323 0 0 1 22.8-11.597c7.32-2.681 17.014-5.1 21.62-1.531 2.148 1.675 2.927 4.075 2.195 6.79-.943 3.51-5.1 9.69-19.544 19.198-3.6 2.37-7.291 4.562-10.647 6.375Z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonio);
export default __webpack_public_path__ + "static/media/personio.a6acfcfe24c60b5a00e8c5626edf4db1.svg";
export { ForwardRef as ReactComponent };